import './CartIcon.scss'

import React, {useEffect, useState} from 'react'
import {MainUrlTypes, Mod} from '../../../../types'
import {useCart} from '../../../../util/cart'
import {useTranslation} from '../../../../util/i18n'
import {Link} from '../../../../util/link'
import {getUrlByKey} from '../../../../util/nav'
import {style} from '../../../../util/style'
import {Icon} from '../../../ui/Icon'

const styles = style('carticon')

export const CartIcon: React.FC<{
	project_key: string
	main_pages: Array<MainUrlTypes>
	mod?: Mod<'fixed' | 'header'>
	headerPosition?: number
}> = ({project_key, main_pages, mod, headerPosition}) => {
	const {cart} = useCart()
	const cartQuantity = cart.quantityTotal()

	const hasItems = cartQuantity > 0

	const t = useTranslation('webshop').header.cart
	const webshopCartUrl = getUrlByKey(main_pages, 'cart')?.url
	const [currentCount, setCurrentCount] = useState(cartQuantity)
	const [countChanged, setCountChanged] = useState(false)
	const [isScrolled, setIsScrolled] = useState(false)

	useEffect(() => {
		const handleScroll = () => {
			const position = window.pageYOffset
			setIsScrolled(position > headerPosition)
		}
		window.addEventListener('scroll', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [headerPosition])

	useEffect(() => {
		if (currentCount !== cartQuantity) {
			setCurrentCount(cartQuantity)
			setCountChanged(true)
			const changedTimeout = setTimeout(() => {
				setCountChanged(false)
			}, 1500)
			return () => clearTimeout(changedTimeout)
		}
	}, [cartQuantity])

	if (!project_key || project_key !== 'webshop') return null

	return (
		<Link
			to={webshopCartUrl}
			target={'_self'}
			title={hasItems ? cartQuantity + ' ' + t.items_in_cart : t.empty}
			className={styles()
				.mod(mod)
				.is({visible: hasItems})
				.is({scrolled: isScrolled})}
		>
			<div className={styles('cart')}>
				<div className={styles('cart-icon')}>
					<Icon icon="shoppingCart" />
				</div>
				{hasItems && (
					<span className={styles('cart-quantity').is({changed: countChanged})}>
						<span className={styles('cart-quantity-number')}>
							{cartQuantity}
						</span>
					</span>
				)}
			</div>
		</Link>
	)
}
